<p-card>
    <p-toast></p-toast>
    <p-steps [model]="items"></p-steps>
</p-card>
<router-outlet></router-outlet>
